import MainContainer from "./Detail.vue";

export default {
  routes: [
    {
      path: "/details",
      component: MainContainer,
    }
  ],
}; 